var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QRCode from "react-qr-code";
import { IoQrCodeOutline } from "react-icons/io5";
import { Button, ButtonGroup, QrCodeContainer, Message, Container } from './style';
import Service from '../../services/Service';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import * as FormActions from '../../store/form/actions';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../TopNavigation';
import { useTranslation } from '../../i18n';
var QrCodeRedirect = function (_a) {
    var step = _a.step, nextStepName = _a.nextStepName, setShow = _a.setShow;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var t = useTranslation().t;
    var _b = useState(false), showQrCode = _b[0], setShowQrCode = _b[1];
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var _c = useSelector(function (state) { return state.form; }), form = _c.form, formInfo = _c.formInfo;
    var validateStep = function () { return __awaiter(void 0, void 0, void 0, function () {
        var productName, tokenOnboarding, response, activeStepIndex, steps, groups, stepIdentifier_1, expectedStep, skipped, _loop_1, i, expectedStepNum, state_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!formInfo)
                        return [2 /*return*/];
                    productName = formInfo.productName, tokenOnboarding = formInfo.tokenOnboarding;
                    if (!productName || !tokenOnboarding)
                        return [2 /*return*/];
                    return [4 /*yield*/, Service.searchByToken(tokenOnboarding, productName)];
                case 1:
                    response = _b.sent();
                    if (response.onboardingDTO) {
                        activeStepIndex = response.numberSteps;
                        steps = response.onboardingDTO.onboardingForm.steps;
                        groups = steps.reduce(function (groups, current) {
                            var stepGroup = current.step.toString().includes('.')
                                ? current.step.toString().split('.')[0] + '.'
                                : current.step.toString();
                            if (!groups.includes(stepGroup)) {
                                return __spreadArray(__spreadArray([], groups, true), [stepGroup], false);
                            }
                            return groups;
                        }, []);
                        stepIdentifier_1 = groups[activeStepIndex];
                        if (stepIdentifier_1.includes('.')) {
                            stepIdentifier_1 = groups[activeStepIndex - 1];
                        }
                        expectedStep = (_a = steps.find(function (step) { return step.step.toString() === stepIdentifier_1; })) === null || _a === void 0 ? void 0 : _a.step;
                        if (expectedStep && expectedStep.toString() !== step.toString()) {
                            skipped = Number(expectedStep) - Number(step);
                            toast.info(t('flow.stepAlreadyDone', { count: skipped }), { autoClose: 3000 });
                            _loop_1 = function (i, expectedStepNum) {
                                var found = form.steps.find(function (formStep) { return formStep.step.toString() === expectedStepNum.toString(); });
                                if (!found) {
                                    dispatch(FormActions.setForm(response.onboardingDTO.onboardingForm));
                                    return "break";
                                }
                            };
                            for (i = 0, expectedStepNum = +expectedStep; i <= expectedStep; i++) {
                                state_1 = _loop_1(i, expectedStepNum);
                                if (state_1 === "break")
                                    break;
                            }
                            navigate('/form', { state: { step: expectedStep, redirect: false } });
                        }
                    }
                    setShow(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderPreStepOptions = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Message, null,
                t('qrcode.nextStep'),
                " ",
                React.createElement("strong", null, nextStepName)),
            React.createElement(Message, null,
                t('qrcode.useCameraInfo'),
                React.createElement("br", null),
                t('qrcode.continueOnThisDevice')),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: validateStep }, t('qrcode.yesContinueHere')),
                React.createElement(Button, { onClick: function () { return setShowQrCode(true); } },
                    React.createElement(IoQrCodeOutline, null),
                    t('qrcode.noUseAnotherDevice')))));
    };
    var renderQrCodeRedirect = function () {
        if (!formInfo)
            return React.createElement(React.Fragment, null);
        var productName = formInfo.productName, tokenOnboarding = formInfo.tokenOnboarding;
        return (React.createElement(React.Fragment, null,
            React.createElement(Message, null, t('qrcode.scanInstruction')),
            React.createElement(QRCode, { size: 128, style: { height: "auto", maxWidth: "100%", width: "100%", marginBottom: '0.5rem' }, value: "".concat(window.location.origin, "/?product=").concat(productName, "&token=").concat(tokenOnboarding, "&redirect=true"), viewBox: "0 0 128 128" }),
            React.createElement(Button, { onClick: function () { return setShowQrCode(false); } }, t('common.back'))));
    };
    return (React.createElement(Container, null,
        React.createElement(TopNavigation, { showLogo: true, showBackButton: form.steps[step].goBack, title: form.steps[step].showStepName ? form.steps[step].stepName : '', headerTransparent: form.steps[step].headerTransparent, headerPadding: theme.logoPosition !== "header" ? 1 : 0 }),
        React.createElement(QrCodeContainer, null, showQrCode ? renderQrCodeRedirect() : renderPreStepOptions())));
};
export default QrCodeRedirect;
